import { List, ListItemText, Tooltip } from 'appkit-react';

export const columnsConfig = (inviteUser, handleModuleChange, moduleMap) => {
    const columns = [
        {
            Header: 'ID',
            accessor: 'id',
            minWidth: 50,
            resizable: true,
            sortable: true,
        },
        {
            Header: 'Email ID',
            accessor: 'email',
            minWidth: 250,
            resizable: true,
            sortable: true,
        },
        {
            Header: 'Institution',
            accessor: 'institution',
            minWidth: 270,
            resizable: true,
            sortable: true,
        },
        {
            Header: 'Invitation',
            accessor: 'invitationStatus',
            minWidth: 100,
            resizable: true,
            sortable: true,
        },
        {
            Header: 'Status',
            accessor: 'status',
            minWidth: 100,
            resizable: true,
            sortable: true,
        },
        {
            Header: 'Expiry Date',
            accessor: 'accessEndDate',
            minWidth: 120,
            resizable: true,
            sortable: true,
            Cell: ({ value }) => {
                if (!value) return '-';
                const formattedDate = new Date(value).toLocaleDateString('en-US', {
                    day: '2-digit',
                    month: 'short',
                    year: 'numeric',
                });
                return formattedDate;
            },
        },
        {
            Header: 'Module',
            accessor: 'module',
            minWidth: 130,
            resizable: true,
            sortable: false,
            Cell: ({ original, value }) => {
                const selectedModule = moduleMap[original.id] || original.module || 'Demo';

                const handleChange = e => {
                    handleModuleChange(original.id, e.target.value);
                };

                return (
                    <select
                        value={selectedModule}
                        onChange={handleChange}
                        className="form-control form-control-sm"
                        disabled={original?.invitationStatus === 'INVITED'}
                    >
                        <option value="Demo">Demo</option>
                        <option value="Benchmark">Benchmark</option>
                    </select>
                );
            },
        },
        {
            Header: 'Actions',
            accessor: 'action',
            minWidth: 80,
            resizable: true,
            sortable: true,
            Cell: ({ original }) => {
                const isInvited = original?.invitationStatus === 'INVITED';

                return (
                    <div className="menu-icon">
                        <Tooltip
                            content={(
                                <List>
                                    <ListItemText
                                        onClick={() => !isInvited && inviteUser(original, moduleMap[original.id] || original.module || 'Demo')}
                                        style={{ color: isInvited ? 'gray' : 'inherit', cursor: isInvited ? 'not-allowed' : 'pointer' }}
                                    >
                                        Invite
                                    </ListItemText>
                                </List>
                            )}
                            trigger="click"
                            refClassName="a-account-info"
                            className="a-account-options"
                            clickToClose
                            tooltipTheme="light"
                            style={{ zIndex: 100, width: '150px' }}
                            disabled={isInvited}
                        >
                            <span
                                className="appkiticon icon-vertical-more-fill a-font-16 a-text-orange"
                                aria-hidden="true"
                                style={{
                                    cursor: isInvited ? 'not-allowed' : 'pointer',
                                    color: isInvited ? '#ccc' : '#f60',
                                }}
                            />
                        </Tooltip>
                    </div>
                );
            },
        },
    ];
    return columns;
};

export const listItems = [
    [
        <i key={1} className="appkiticon icon-person-outline icon" style={{ fontSize: '1.5rem', color: '#464646', top: '100px' }} />,
        <span key={2} className="a-nav-item-text" style={{ color: '#464646', fontSize: '0.7rem' }}>User</span>,
    ],
    [
        <i key={1} className="appkiticon icon-management-outline icon" style={{ fontSize: '1.5rem', color: '#464646', top: '100px' }} />,
        <span key={2} className="a-nav-item-text" style={{ color: '#464646', fontSize: '0.7rem' }}>Tenant</span>,
    ],
    [
        <i key={1} className="appkiticon icon-ticket-outline icon" style={{ fontSize: '1.5rem', color: 'white', top: '100px' }} />,
        <span key={2} className="a-nav-item-text" style={{ color: 'white', fontSize: '0.7rem' }}>Intake</span>,
    ],
];

export const ADD_LATER = '';
